import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useLocation, useNavigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Preloader } from "@/components/Preloader";
import { ChatBot } from "@/components/ChatBot";
import { CookieConsent } from "@/components/CookieConsent";
import { FloatingCall, CustomCursor } from "@/components/Chrome";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import Referenzen from "@/pages/Referenzen";
import UeberUns from "@/pages/UeberUns";
import Kontakt from "@/pages/Kontakt";
import Karriere from "@/pages/Karriere";
import { Privat, Unternehmen, Kommunen } from "@/pages/audiences";
import { LegalPage } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import "@/App.css";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    window.__lenis?.scrollTo(0, { immediate: true });
  }, [pathname]);
  return null;
};

const NavBridge = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.__navigate = navigate;
  }, [navigate]);
  return null;
};

const Shell = () => (
  <>
    <Navbar />
    <FloatingCall />
    <CustomCursor />
    <ChatBot />
    <CookieConsent />
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: !reduced });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <NavBridge />
      <ScrollToTop />
      <Preloader />
      <Routes>
        <Route element={<Shell />}>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/referenzen" element={<Referenzen />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/karriere" element={<Karriere />} />
          <Route path="/privat" element={<Privat />} />
          <Route path="/unternehmen" element={<Unternehmen />} />
          <Route path="/kommunen" element={<Kommunen />} />
        </Route>
        <Route path="/impressum" element={<LegalPage kind="impressum" />} />
        <Route path="/datenschutz" element={<LegalPage kind="datenschutz" />} />
        <Route path="/agb" element={<LegalPage kind="agb" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#1E271C",
            border: "1px solid #DDD3C2",
            borderRadius: "12px",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
